import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '', text = '' }) => {
    const sizes = {
        sm: 'h-4 w-4 border-2',
        md: 'h-8 w-8 border-2',
        lg: 'h-12 w-12 border-b-2',
        xl: 'h-16 w-16 border-b-2'
    };

    return (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <div className={`animate-spin rounded-full ${sizes[size]} border-blue-600`}></div>
            {text && <p className="mt-4 text-gray-600">{text}</p>}
        </div>
    );
};

export default LoadingSpinner;
